import React, {
	useEffect,
	useRef,
	useState,
	useCallback,
} from 'react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import { FiAlertCircle } from 'react-icons/fi';
import Select, { Props as SelectedProps } from 'react-select';
import AsyncSelect from 'react-select/async';

import { Container, Error } from './styles';
import { Flex } from '@chakra-ui/react';

type OptionData = {
	value: string;
	label: string;
};
interface SelectProps extends SelectedProps {
	name: string;
	icon?: React.ComponentType<IconBaseProps>;
	containerStyle?: object;
	options: OptionData[];
	placeholder?: string;
};

const SelectInputAntigo: React.FC<SelectProps> = ({
	name,
	icon: Icon,
	options,
	placeholder,
	containerStyle,
	...rest
}) => {
	const inputRef = useRef<any>(null);
	const iconRef = useRef<any>(null);

	const [isFocused, setIsFocused] = useState(false);
	const [isField, setIsField] = useState(false);
	const { fieldName, defaultValue, error, registerField } = useField(name);

	const handleInputFocus = useCallback(() => {
		setIsFocused(true);
	}, []);

	const handleInputBlur = useCallback(() => {
		setIsFocused(false);
		setIsField(!!inputRef.current?.value);
	}, []);

	useEffect(() => {
		registerField({
			name: fieldName,
			ref: inputRef.current,
			path: undefined,
			getValue: (ref) => {
				if (rest.isMulti) {
					if (!ref.state.value) {
						return [];
					}
					return ref.state.value.map(
						(option: OptionData) => option.value,
					);
				}
				if (!ref.state.value) {
					return '';
				}
				return ref.state.value.value;
			},
			setValue: (ref: any, value: string) => {
				// ref.select.setValue(value || null);
				// ref.inputRef.value = value;
				// ref.state.value = value;
				ref.setValue(value);
				// ref.state.value = value;
				// ref.state.selectValue = [value];
			},
			clearValue: (ref, newValue) => {
				// ref.select.clearValue();
				ref.state.value = newValue;
				ref.clearValue();
			}
		});
	}, [fieldName, registerField]);

	return (
		<Container
			isErrored={!!error}
			isField={isField}
			isFocused={isFocused}
			style={containerStyle}
		>
			{Icon && <Icon size={20} />}

			<Select
				// dropdownPosition="auto"
				onBlur={handleInputBlur}
				onFocus={handleInputFocus}
				options={options}
				defaultValue={defaultValue}
				isMulti={false}
				ref={inputRef}
				{...rest}

				placeholder={placeholder}
				noOptionsMessage={() => 'sem opções'}
				isSearchable
				isClearable={false}

				styles={{
					container: (defaultStyles) => ({
						...defaultStyles,
						flex: 1,
						padding: '0',
						// border: '2px solid red'
					}),
					control: (baseStyles) => ({
						...baseStyles,
						borderRadius: 6,
						border: 'none', // '1px solid #b0bec5',
						color: "#333",
						fontWeight: 500,
						boxShadow: 'none',
						cursor: 'pointer'
					}),
					placeholder: (defaultStyles) => {
						return {
							...defaultStyles,
							color: "#90a4ae"
						}
					},
					indicatorSeparator: (defaultStyles) => ({
						...defaultStyles,
						display: 'none',
					}),
					indicatorsContainer: (defaultStyles, state) => ({
						...defaultStyles,
						padding: '0',
						'svg': {
							marginRight: '8px',
						}
					}),
					dropdownIndicator: defaultStyles => ({
						...defaultStyles,
						color: "#333",
						padding: '0',
						// border: '2px solid blue',

						'&:hover': {
							color: '#2196f3'
						},
					}),
					menu: (defaultStyles) => ({
						...defaultStyles,
						position: "absolute",
					})
				}}
			/>

			{error && (
				<Error title={error}>
					<Flex pr={1} ref={iconRef}>
						<FiAlertCircle color="#c53030" size={20} />
					</Flex>
				</Error>
			)}
		</Container>
	);
};

export default SelectInputAntigo;